<template>
    <div class="m-judge" :id="judgeArr.id">
        <div v-for="item in judgeArr" :key="item.id">
            <Title v-if="item.category=='title'" :titleArr="item.data"></Title>

            <div v-else class="clearfix">
                <div v-for="itemele in item.data" :key="itemele.id" class="m-judge-item">
                    <div class="m-img-box">
                        <img class="lazyImg" :alt="itemele.name" :data-src="itemele.pic" />
                    </div>
                    <p>{{itemele.name}}</p>
                    <span>{{itemele.position}}</span>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import Title from "@/components/Title";
export default {
    name: "Judge",
    props: {
        judgeArr: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    components: {
        Title
    },
    data() {
        return {
            msg: "judge"
        };
    }
};
</script>  
